<template>
	<o-loading :full-page="Boolean(false)" :active="showLoading" :can-cancel="false">
  </o-loading>
	<mf-table
		ref="itemBIMPLUSTable"
    :tableProps="tableProps"
    :loadData="loadData"
    tableName="itemLocs"
    :hideGutter="true"
    :api-mode="false"
    @cell-clicked="onCellClicked"
		:key="data.length"
    tableClass="bimplus-flyout">
		<template #viewBIM="{ rowData }">
			<div  @click="loadBIMPLUS(rowData)" class="is-clickable is-flex is-align-items-center is-justify-content-center">
				<i class="icon-show"></i>
			</div>
		</template>
	</mf-table>
</template>

<script>
import { computed, inject, defineComponent, reactive, toRefs, ref } from 'vue';
import MfTable from '@/components/table-fields/MfTable.vue';
import BIMPLUSItemsViewCols from '../table-cols/BIMPLUSItemsViewCols';
export default defineComponent({
	props: {
		rowData: Object,
	},
	components: {
		MfTable,
	},
	setup({rowData}) {
		const itemBIMPLUSTable = ref(null);
		const emitter = inject('emitter');
		const state = reactive({
			showLoading: false,
			data: rowData.guids,
		});
		const tableProps = computed(() => ({
      showHeader: true,
      fields: BIMPLUSItemsViewCols.fields,
    }));
		const loadData = () => state.data;
		const onCellClicked = async (e) => {
			console.log('onCellClicked');
		};
		const loadBIMPLUS = (rowData) => {
			emitter.emit('isolateFromGuidLvl', rowData);
		}
		return {
			...toRefs(state),
			tableProps,
			loadData,
			loadBIMPLUS,
			onCellClicked,
		}
	}
})
</script>